export default __webpack_public_path__ + "static/media/deleted-icon.92fe49ff.svg";